/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartDonut = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 4v6h-1a3 3 0 1 0 3 3v-1h6v1a9 9 0 1 1-9-9zm1.757 13.172a4.973 4.973 0 0 1-2.54.823L11 18a4.977 4.977 0 0 1-2.757-.828l-1.435 1.434A6.969 6.969 0 0 0 11 20a6.969 6.969 0 0 0 4.192-1.393zM17.928 14h-2.03l-.01.059a4.972 4.972 0 0 1-.717 1.699l1.436 1.433a6.965 6.965 0 0 0 1.294-3.01zM10 6.071l-.182.028a7.002 7.002 0 0 0-4.424 11.093l1.434-1.435a5.002 5.002 0 0 1 3.113-7.645L10 8.101zM14 2c4.421 0 8 3.579 8 8v1h-6v-1c0-1.106-.894-2-2-2h-1V2zm1 2.083v2.043l.156.043a4.006 4.006 0 0 1 2.675 2.675l.042.156h2.043l-.017-.103A6 6 0 0 0 15.103 4.1z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartDonut as ChartDonut };
